import { useQuery } from '@tanstack/react-query';
import { getCustomer } from '../customerAPI';

export function useCustomer(customerId: string) {
  return useQuery({
    queryKey: ['customer', customerId],
    queryFn: () => getCustomer(customerId),
    enabled: !!customerId,
  });
}
